// Pure rules shared by the server and the web app.

export type Role = 'admin' | 'user';
export const ROLE_LABEL: Record<Role, string> = { admin: 'Admin', user: 'User (view only)' };

export const QC = ['Done', 'Pending', 'Not needed'] as const;
export type Qc = (typeof QC)[number];

export const INSTALL = ['Installed', 'Pending', 'Not needed'] as const;
export type Install = (typeof INSTALL)[number];

/** Dropdown lists that admins manage in Settings. Custom dropdown columns use `col:<id>`. */
export const LISTS = ['type', 'project', 'resource'] as const;
export type FixedList = (typeof LISTS)[number];
export const LIST_LABEL: Record<FixedList, string> = { type: 'Type', project: 'Project', resource: 'Resource' };
export const colList = (id: number) => `col:${id}`;

export const DEFAULT_TYPES = ['Raw material', 'Assembled device', 'Tools'];

export const COLUMN_KINDS = ['text', 'number', 'dropdown'] as const;
export type ColumnKind = (typeof COLUMN_KINDS)[number];

export const PASSWORD_MIN = 8;
export const validPassword = (p: string) => p.length >= PASSWORD_MIN && p.length <= 200;

/** Quantities may be decimals (e.g. metres of cable); keep two decimals to avoid float noise. */
export const round2 = (n: number) => Math.round(n * 100) / 100;
export const fmtQty = (n: number) => String(round2(n));

/** True when the item has a minimum and its warehouse quantity is at or below it. */
export const atMinimum = (qty: number, min: number | null | undefined) => min != null && qty <= min;

export function ymdInTz(d: Date, tz: string): string {
  // en-CA formats as YYYY-MM-DD
  return new Intl.DateTimeFormat('en-CA', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit' }).format(d);
}
